export class ImportValueMap<TRow> {
    public Rows: TRow[];

    public Cols: string[];

    public constructor(json?: any) {
        if (!json) {
            this.Rows = [];
            this.Cols = [];

            return;
        }
        this.Rows = json.Rows;
        this.Cols = json.Cols;
    }
}
